import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL Target Niche
export const nicheList = (params = '') => Http.get(`/marketing-niches${serialize(params)}`)
export const nicheCreate = (params = '') => Http.post('/marketing-niches', params)
export const nicheByID = (params = '') => Http.get(`/marketing-niches/${params}`)
export const nicheUpdate = (params = '') => Http.put(`/marketing-niches/${params.id}`, params)
export const nicheDestroy = (params = '') => Http.delete(`/marketing-niches/${params.id}`)
